import {CommandIconButton} from '@github-ui/ui-commands/components/CommandIconButton'
import {SearchIcon} from '@primer/octicons-react'
import {clsx} from 'clsx'

import styles from './SearchButton.module.css'

export default function SearchButton({className, onClick}: {className?: string; onClick?: () => void}) {
  return (
    <CommandIconButton
      aria-label="Search this repository"
      tooltipDirection="nw"
      icon={SearchIcon}
      commandId="global-navigation:search"
      size="medium"
      className={clsx(styles.IconButton, className)}
      onClick={onClick}
    />
  )
}
